/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const updateWhatsAppBusinessProfileDataVerticalSchema = z.enum([
	'OTHER',
	'AUTO',
	'BEAUTY',
	'APPAREL',
	'EDU',
	'ENTERTAIN',
	'EVENT_PLAN',
	'FINANCE',
	'GROCERY',
	'GOVT',
	'HOTEL',
	'HEALTH',
	'NONPROFIT',
	'PROF_SERVICES',
	'RETAIL',
	'TRAVEL',
	'RESTAURANT',
	'ALCOHOL',
	'ONLINE_GAMBLING',
	'PHYSICAL_GAMBLING',
	'OTC_DRUGS',
	'MATRIMONY_SERVICE',
])

export type UpdateWhatsAppBusinessProfileDataVerticalSchema = z.infer<
	typeof updateWhatsAppBusinessProfileDataVerticalSchema
>
